import React, { useState } from 'react'
import { RestApi } from '../../RestApi'
import GLOBAL from '../../Globals'
import { Button, Modal, Upload, message } from 'antd'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { CloudUploadOutlined, CopyTwoTone } from '@ant-design/icons'
import { Paper, Typography } from '@mui/material'

const UploadAndGetLinks = ({ customUrl = '', isModal = true }) => {
    const [loading, setLoading] = useState(false)
    const [addModalVisible, setAddModalVisible] = useState(false)
    const [fileList, setFileList] = useState([])
    const [uploadedLinks, setUploadedLinks] = useState([])
    const showAddModal = () => {
        setAddModalVisible(true)
    }
    const hideAddModal = () => {
        setAddModalVisible(false)
    }
    const upload = async () => {
        if (fileList.length === 0) {
            message.error('Select files to upload!')
            return
        }
        setLoading(true)
        const apiUrl = customUrl || GLOBAL.URL.UPLOAD_TO_S3
        for (const file of fileList) {
            const formData = new FormData()
            formData.append('file', file)
            try {
                const response = await RestApi.doPost(apiUrl, formData)
                const res = JSON.parse(response.data)
                setUploadedLinks((prev) => [
                    ...prev,
                    { name: file.name, location: res.location },
                ])
            } catch (error) {}
        }
        setFileList([])
        setLoading(false)
    }
    const onCopy = () => {
        message.success('Link copied!')
    }
    const uploadProps = {
        multiple: true,
        onRemove: (file) => {
            setFileList((prev) => prev.filter((item) => item.uid !== file.uid))
        },
        beforeUpload: (file) => {
            setFileList((prev) => [...prev, file])
            return false
        },
        fileList,
    }
    const UploadCard = () => {
        return (
            <Paper
                elevation={2}
                style={{
                    padding: '5px 20px 10px',
                    marginTop: 20,
                    borderRadius: '10px',
                }}
            >
                <h4>Select Files:</h4>
                <Upload {...uploadProps}>
                    <Button>
                        <CloudUploadOutlined /> Select
                    </Button>
                </Upload>
                {fileList.length > 0 && (
                    <div style={{ marginTop: 20 }}>
                        <Button
                            type="primary"
                            size="small"
                            loading={loading}
                            onClick={upload}
                        >
                            Upload
                        </Button>
                    </div>
                )}
                {uploadedLinks.length ? (
                    <div style={{ marginTop: 20 }}>
                        {uploadedLinks.map((item, idx) => (
                            <div key={idx} style={{ marginBottom: 10 }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4,
                                    }}
                                >
                                    <Typography>{idx + 1}. </Typography>
                                    <CopyToClipboard
                                        text={item.location}
                                        onCopy={onCopy}
                                    >
                                        <Button
                                            type="link"
                                            style={{ padding: 0 }}
                                        >
                                            <CopyTwoTone />
                                            {item.name}
                                        </Button>
                                    </CopyToClipboard>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </Paper>
        )
    }
    return (
        <span>
            {addModalVisible ? (
                isModal ? (
                    <Modal
                        title="Upload And Get Links"
                        open={addModalVisible}
                        confirmLoading={loading}
                        onCancel={hideAddModal}
                        okText="Upload"
                        destroyOnClose
                        footer={null}
                    >
                        <UploadCard />
                    </Modal>
                ) : (
                    <UploadCard />
                )
            ) : (
                <Button size="small" onClick={showAddModal}>
                    Upload Files and Get Links
                </Button>
            )}
        </span>
    )
}
export default UploadAndGetLinks
